import { render, staticRenderFns } from "./DomainComponentLazy.vue?vue&type=template&id=5bff9f02&"
import script from "./DomainComponentLazy.vue?vue&type=script&lang=js&"
export * from "./DomainComponentLazy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports